import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import React from 'react';

import './Checkbox.scss';
import Icon from './Icon';

interface ICheckboxProps {
  name: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
  hasError?: boolean;
}

const Checkbox: FC<ICheckboxProps> = ({
  name,
  checked,
  onChange,
  children,
  hasError = false
}) => {
  return (
    <div className={classNames('styled-checkbox', {
      'has-error': hasError && !checked,
      'is-checked': checked
    })}>
      <label>
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={e => onChange(e.target.checked)}
        />
        <span className="checkbox-box">
          <Icon icon="checkmark" />
        </span>
        <span className="checkbox-label">{children}</span>
      </label>
    </div>
  );
};

export default Checkbox;
